import { GetterTree } from "vuex";
import { INotificationState } from "./interface";
import { IStoreRootState } from "@/store/interface";
import { isImportantNotificationStatus } from "./utils";

export default <GetterTree<INotificationState, IStoreRootState>> {
	toasts: state => state.toasts.filter(toast =>
		!isImportantNotificationStatus(toast.status)),
	importantToasts: state => state.toasts.filter(toast =>
		isImportantNotificationStatus(toast.status))
}